var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.transformedUser != null)?_c('div',[_c('mgt-person',{attrs:{"person-details":JSON.stringify(_vm.transformedUser),"view":_vm.mgtView}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }